function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var HtmlTrackElementList = function () {
    function HtmlTrackElementList() {
        var trackElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, HtmlTrackElementList);
        this.trackElements_ = [];
        Object.defineProperty(this, 'length', {
            get: function get() {
                return this.trackElements_.length;
            }
        });
        for (var i = 0, length = trackElements.length; i < length; i++) {
            this.addTrackElement_(trackElements[i]);
        }
    }
    _createClass(HtmlTrackElementList, [
        {
            key: 'addTrackElement_',
            value: function addTrackElement_(trackElement) {
                var index = this.trackElements_.length;
                if (!('' + index in this)) {
                    Object.defineProperty(this, index, {
                        get: function get() {
                            return this.trackElements_[index];
                        }
                    });
                }
                if (this.trackElements_.indexOf(trackElement) === -1) {
                    this.trackElements_.push(trackElement);
                }
            }
        },
        {
            key: 'getTrackElementByTrack_',
            value: function getTrackElementByTrack_(track) {
                var trackElement_;
                for (var i = 0, length = this.trackElements_.length; i < length; i++) {
                    if (track === this.trackElements_[i].track) {
                        trackElement_ = this.trackElements_[i];
                        break;
                    }
                }
                return trackElement_;
            }
        },
        {
            key: 'removeTrackElement_',
            value: function removeTrackElement_(trackElement) {
                for (var i = 0, length = this.trackElements_.length; i < length; i++) {
                    if (trackElement === this.trackElements_[i]) {
                        this.trackElements_.splice(i, 1);
                        break;
                    }
                }
            }
        }
    ]);
    return HtmlTrackElementList;
}();
export default HtmlTrackElementList;